import useDeleteData from '../../../../../hooks/deleteHook';

export const useDeleteSubcategory = () => {
  const [{ isCompleted, isLoading, isError, error }, doDelete] =
    useDeleteData();

  return { isCompleted, isLoading, isError, error, doDelete };
};
